import request from '@/utils/request'
import { useUserStore } from '@/store/user'
import { http } from '@/utils/http'

const baseUrl = import.meta.env.VITE_SERVER_BASEURL

/**
 * 批量获取选项字典数据
 * @param {string} dictCodeList - 字典编码列表，用逗号分隔
 * @returns {Promise}
 */
export function getManyDictItems(dictCodeList) {
  return new Promise((resolve, reject) => {
    const userStore = useUserStore()
    const header = {}
    if (userStore.userInfo.token) {
      header['X-Access-Token'] = userStore.userInfo.token
    }

    uni.request({
      url: baseUrl + '/sys/api/getManyDictItems',
      method: 'get',
      header,
      data: {
        dictCodeList: dictCodeList.join(','),
      },
      success: (res) => {
        resolve(res.data)
      },
      fail: (err) => {
        reject(err)
      },
    })
  })
}

/**
 * 获取在线报表配置列
 * @param {string} reportCode - 报表编码
 * @returns {Promise}
 */
export function getRpColumns(reportCode) {
  return http.get(`/online/cgreport/api/getRpColumns/${reportCode}`)
  // return request({
  //   url: `/online/cgreport/api/getRpColumns/${reportCode}`,
  //   method: 'get',
  // })
}

/**
 * 获取在线报表数据
 * @param {string} cgRpConfigId - 报表配置ID
 * @param {object} params - 查询参数，例如 { pageNo: 1, pageSize: 10 }
 * @returns {Promise}
 */
export function getColumnsAndData(cgRpConfigId, params) {
  return http.get(`/online/cgreport/api/getColumnsAndData/${cgRpConfigId}`, params)
  // return request({
  //   url: `/online/cgreport/api/getColumnsAndData/${cgRpConfigId}`,
  //   method: 'get',
  //   data: params,
  // })
}
